import { connect } from 'react-redux';
import IntroductionLayer from '../components/IntroductionLayer/IntroductionLayer';
import {
    nextStep,
    resetSteps,
    toggleVisibility,
} from '../actions/actionCreators/introductionLayer';

function mapStateToProps(state) {
    return {
        step: state.introductionLayer.step,
        isOpen: state.introductionLayer.isOpen,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        toggleVisibility: () => dispatch(toggleVisibility()),
        nextStep: () => dispatch(nextStep()),
        resetSteps: () => dispatch(resetSteps()),
    };
}

const IntroductionLayerContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(IntroductionLayer);

export default IntroductionLayerContainer;
